import {createAsyncThunk} from '@reduxjs/toolkit'

import {getSaleHistoryDetailByApi} from '@web/actions/saleHistory'
import {isApiAsyncThunkServerPayload} from '@web/helpers/api'

import {ThunkApi} from '../interfaces'

const actionType = 'saleHistoryDetail'

/** 판매상세 초기화 action */
export const initSaleHistoryDetail = createAsyncThunk<{orderNo: string}, string, ThunkApi>(
    `${actionType}/init`,
    async (orderNo, {dispatch, rejectWithValue}) => {
        if (!orderNo) {
            return rejectWithValue({
                code: 'ORDER_NO_FAIL',
                message: 'orderNo 이상',
            })
        }

        try {
            await dispatch(getSaleHistoryDetailByApi({orderNo})).unwrap()
        } catch (e) {
            if (isApiAsyncThunkServerPayload<{code: string; fallbackMessage: string}>(e)) {
                return rejectWithValue({
                    code: e.value.response.result.code,
                    message: e.value.response.result.fallbackMessage,
                })
            }
            throw e
        }

        return {orderNo}
    },
)
